export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const DISPLAY_DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';
export const DISPLAY_DATE_FORMAT = 'MMM D, YYYY';
